module.exports = __webpack_public_path__ + "static/selects-placeholdersize-dont-7bb79167309b689fb5aa6a56a9ede216.png";